import { render, staticRenderFns } from "./AppTableControl.vue?vue&type=template&id=0b4193d9&scoped=true&"
import script from "./AppTableControl.vue?vue&type=script&lang=js&"
export * from "./AppTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4193d9",
  null
  
)

export default component.exports